import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Box } from '@mui/material';

const ChiefObjective = ({ variant = 'default', company }) => {
  // variant: default, compact or inline

  // Hardcoded list of companies with 1 win per month
  const oneWinCompanies = [
    'assurancehomecare',
    'bonnlaw',
    'onelifecounselling&coaching',
    'ottawamovinglogistics',
    'revnetottawa',
    'securityguardsonly',
    'seoplus+',
    'thesmithinvestigationagency',
    'straderferrisinternational',
    'talentlab',
    'themortgageadvisors',
    'thesustainableagavecompany',
    'tinyhoppers',
    'tophathomecomfortservices',
    'yeastinfectionadvisor',
  ];
  const winsPerMonth = oneWinCompanies.includes(company) ? 1 : 2;

  const baseStyles = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: { xs: 'flex-start', sm: 'center' },
    justifyContent: 'center',
    gap: 0,
  };

  return (
    <Box sx={baseStyles}>
      {variant === 'inline' ? (
        <Typography variant="body2" sx={{ fontSize: '0.875rem', lineHeight: 1 }}>
          👑 Chief objective: {winsPerMonth} win{winsPerMonth === 1 ? '' : 's'} per month
        </Typography>
      ) : (
        <>
          <Typography
            variant="body2"
            sx={{
              fontSize: variant === 'compact' ? '1.6rem' : '3rem',
              color: 'warning.main',
              lineHeight: 1,
            }}
          >
            👑
          </Typography>
          <Typography variant="body2" sx={{ fontSize: variant === 'compact' ? '1rem' : '1.2rem' }}>
            Chief objective:
          </Typography>
          <Typography variant="h6" sx={{ fontSize: variant === 'compact' ? '1rem' : '1.2rem' }}>
            {winsPerMonth} win{winsPerMonth === 1 ? '' : 's'} per month
          </Typography>
        </>
      )}
    </Box>
  );
};

ChiefObjective.propTypes = {
  variant: PropTypes.oneOf(['default', 'compact', 'inline']),
  company: PropTypes.string,
};

export default ChiefObjective;
